import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, TS_ProgressBar } from '@nu-art/thunderstorm-frontend/index';
import './PgDev_ProgressBar.scss';
class PgDev_ProgressBar_Class extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        return { ratio: 0 };
    }
    componentDidMount() {
        setInterval(() => {
            let ratio = this.state.ratio + 0.01;
            if (ratio > 1)
                ratio = 0;
            this.setState({ ratio });
        }, 50);
    }
    render() {
        return _jsxs("div", { id: 'pg-dev-progress-bar', children: [_jsx(TS_ProgressBar, { ratios: [this.state.ratio] }), _jsx(TS_ProgressBar, { ratios: [this.state.ratio], type: 'radial' })] });
    }
}
export const PgDev_ProgressBar = {
    name: 'Progress Bar Test',
    key: 'progress-bar-test',
    renderer: PgDev_ProgressBar_Class
};
